import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CustomerAuthContext = createContext({
  customer: null, // null=loading, false=anonymous, object=signed in
  loading: true,
  refresh: () => {},
  logout: () => {},
});

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/customers/auth/me`, { withCredentials: true });
      setCustomer(r.data);
    } catch {
      setCustomer(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Skip auto-check while OAuth callback is processing the session_id fragment.
    // AuthCallback will explicitly call refresh() once the cookie is set.
    if (typeof window !== 'undefined' && window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try {
      await axios.post(`${API}/customers/auth/logout`, {}, { withCredentials: true });
    } catch {}
    setCustomer(false);
  }, []);

  return (
    <CustomerAuthContext.Provider value={{ customer, loading, refresh, logout }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
